import { render, staticRenderFns } from "./examroom.vue?vue&type=template&id=599c972a&scoped=true&"
import script from "./examroom.vue?vue&type=script&lang=js&"
export * from "./examroom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599c972a",
  null
  
)

export default component.exports